import getCancelledStudiesApi from "@custom/rtk-apis/teleradiologist/getCancelledStudy";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  reviewStatusResult:[],
  error:""
};

const cancelledStudiesSlice = createSlice({
  name: "cancelledStudiesSlice",
  initialState,
  reducers: {
    cleargetCancellesStudies: state => {
      state.status = '';
      state.result = '';
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCancelledStudiesApi.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getCancelledStudiesApi.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload.data;
        state.reviewStatusResult = payload.reviewStatusResult
        state.msg = payload.msg;
      })
      .addCase(getCancelledStudiesApi.rejected, (state, payload) => {
        state.result = [];
        state.loading = false;
      });
  },
});

export default cancelledStudiesSlice.reducer;
export const { cleargetCancellesStudies } = cancelledStudiesSlice.actions;
